<div>
  <div class="w-full flex justify-between items-center">
    <div class="text-cafe text-lg sm:text-[25px] font-bold font-['Roboto']">
      {{tittle}}
    </div>
    <button (click)="ToggleExpanded()" class="cursor-pointer transition-transform duration-300 ease-in-out">
      <div class="transform transition-transform duration-200" [ngClass]="{ 'rotate-180': expanded() }">
        <ln-chevron-down-svg-icon [class]="'w-4 h-6'"></ln-chevron-down-svg-icon>
      </div>
    </button>
  </div>
  @if(expanded()) {
    <div class="mt-2 text-base font-normal sm:mt-4 sm:text-[16px]">
      <ng-content select="[body]"></ng-content>
    </div>
  }
</div>
